import React, { Component } from 'react';
import trans from 'translate';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { silentLogin } from 'redux/actions/walletActions';
import NotConnectedBlocker from './NotConnectedBlocker';
import Loader from '../Common/Loader/Loader';
import ProtectedRoute from '../hoc/ProtectedRoute/ProtectedRoute';

class AccountRouteChecker extends Component {
  constructor(props) {
    super(props);
    const { history } = this.props;
    this.history = history;

    this.state = {};
  }

  componentDidMount() {
    this.login();
  }

  componentDidUpdate(prevProps) {
    const { requireLogin, account, accountType, shouldSetKey } = this.props;

    const requiredLoginChanged = requireLogin !== prevProps.requireLogin;
    const accountChanged = account && prevProps.account && account !== prevProps.account;
    const accountTypeChanged = accountType && prevProps.accountType && accountType !== prevProps.accountType;

    if (accountChanged || accountTypeChanged || requiredLoginChanged) this.login();
    if (accountChanged && shouldSetKey) this.setKey(`${account}-${accountType}`);
  }

  setKey(key) {
    this.setState({ key });
  }

  showUnverifiedUserErrorOnce() {
    // add the error query once and then remove it so user will not get it at every refresh
    // this.history.push('/?error=user_not_verified');
    setTimeout(() => {
      // this.history.push('/');
    }, 1000);
  }

  async login() {
    this.props.silentLogin();
  }

  render() {
    const { key } = this.state;
    const {
      isPrivate,
      component: Component,
      account,
      connectingWalletProvider,
      connectingWallet,
      requireLogin,
      connectingWalletAccountType,
      blockerPageTitle,
      additional,
      ...rest
    } = this.props;

    const showLoader = requireLogin && (connectingWalletProvider || connectingWallet);

    if (showLoader) {
      let message = '';

      if (connectingWallet) message = `${trans('common.connecting')}...`;
      if (connectingWalletProvider) {
        message = trans('common.connecting_wallet');
      }

      return (
        <div className="checker-loader-container page-wrapper width-container">
          <Loader message={message} />
        </div>
      );
    }

    if (key) additional.key = key;

    let content;

    if (requireLogin && !account) {
      content = <NotConnectedBlocker blockerPageTitle={blockerPageTitle} />;
    } else {
      content = <ProtectedRoute render={(props) => <Component {...props} {...additional} />} {...rest} />;
    }

    return content;
  }
}

AccountRouteChecker.defaultProps = {
  account: '',
  accountType: '',
  requireLogin: false,
  requireVerifiedChampion: false,
  shouldSetKey: false,
  isPrivate: false,
  blockerPageTitle: '',
  additional: {},
  championData: null,
  connectingWalletAccountType: null,
};

AccountRouteChecker.propTypes = {
  accountType: PropTypes.string,
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  silentLogin: PropTypes.func.isRequired,
  connectingWalletProvider: PropTypes.bool.isRequired,
  isChampionVerified: PropTypes.bool.isRequired,
  connectingWallet: PropTypes.bool.isRequired,
  connectingWalletAccountType: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  account: PropTypes.string,
  requireLogin: PropTypes.bool,
  championData: PropTypes.object,
  requireVerifiedChampion: PropTypes.bool,
  shouldSetKey: PropTypes.bool,
  additional: PropTypes.object,
  isPrivate: PropTypes.bool,
  blockerPageTitle: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const mapStateToProps = ({ wallet, champion }) => ({
  account: wallet.account,
  accountType: wallet.accountType,
  connectingWalletProvider: wallet.connectingWalletProvider,
  connectingWallet: wallet.connectingWallet,
  connectingWalletAccountType: wallet.connectingWalletAccountType,
  isChampionVerified: champion.championData?.is_verified_champion === 'VERIFIED',
  championData: champion.championData,
});

const mapDispatchToProps = { silentLogin };

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AccountRouteChecker));
